import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealLines } from "@/components/motion";
import { EmptyState } from "@/components/EmptyState";
import { BLOGS } from "@/data/content";

export const JournalPreview = () => {
  const navigate = useNavigate();
  return (
    <section id="journal" className="py-28 md:py-40 bg-[#FDFBF7]" data-testid="journal-preview">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-6">— The Journal</p>
            <h2 className="font-serif font-light text-5xl md:text-6xl tracking-tight leading-none">
              <RevealLines lines={["Notes on building", "brands worth believing."]} />
            </h2>
          </div>
          <button
            onClick={() => navigate("/blogs")}
            data-testid="view-all-blogs"
            className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] whitespace-nowrap"
          >
            All articles
            <ArrowUpRight size={16} className="text-[#C5A059] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {BLOGS.length === 0 && <EmptyState label="Journal — coming soon" note="Insights on brand strategy will be published here soon." />}
          {BLOGS.map((b, i) => (
            <Reveal key={b.slug} i={i}>
              <button
                onClick={() => navigate(`/blogs/${b.slug}`)}
                data-testid={`blog-card-${b.slug}`}
                className="group text-left w-full border-t border-[#E8E4D9] pt-6"
              >
                <div className="relative overflow-hidden h-[220px] mb-5">
                  <img src={b.img} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-[#78716C]">
                  <span className="text-[#C5A059]">{b.tag}</span> · {b.date} · {b.read}
                </div>
                <h3 className="font-serif text-2xl md:text-[1.7rem] mt-3 leading-tight group-hover:text-[#8a6d2f] transition-colors">
                  {b.title}
                </h3>
                <p className="text-sm text-[#78716C] mt-3 leading-relaxed">{b.excerpt}</p>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
